// extracted by mini-css-extract-plugin
export default {"mainDiv":"Table_mainDiv__B29Xo"};